import "../../chunk-7QVYU63E.js";
import { AnnouncementBannerSchema } from "#cards/announcementBanner.js";
import { JustShippedCardSchema } from "#cards/justShippedCard.js";
import { z } from "zod";
var Flag = /* @__PURE__ */ function(Flag2) {
  Flag2["ActivityLogs"] = "activity_logs";
  Flag2["ShowThemeToggle"] = "show_theme_toggle";
  Flag2["ProductTimeseriesCharts"] = "product_timeseries_charts";
  Flag2["ShowDisableApiKeyToggle"] = "show_disable_api_key_toggle";
  Flag2["WhitelistIpRanges"] = "whitelist_ip_ranges";
  Flag2["ShowTeamIpAllowlist"] = "show_team_ip_allowlist";
  Flag2["ShowMethodAndNetworkInErrorAlert"] = "show_method_and_network_in_error_alert";
  Flag2["AdminAccessKeys"] = "admin_access_keys";
  Flag2["Rbac"] = "rbac";
  Flag2["TransactionLifecycleDashboard"] = "transaction_lifecycle_dashboard";
  Flag2["TenderlyDebug"] = "tenderly_debug";
  Flag2["WebhookCreationTemplate"] = "webhook_creation_template";
  Flag2["AnnouncementBanner"] = "announcement_banner";
  Flag2["FeaturedChains"] = "featured_chains";
  Flag2["JustShippedCards"] = "just_shipped_cards";
  Flag2["OutageBanner"] = "outage_banner";
  Flag2["ScheduleCallPopover"] = "schedule_call_popover";
  Flag2["WalletServices"] = "wallet_services";
  Flag2["GlobalBanner"] = "global_banner";
  Flag2["CustomJwtProvider"] = "custom_jwt_provider";
  return Flag2;
}({});
const FlagEnum = z.nativeEnum(Flag);
const UnvalidatedNetworkIdsSchema = z.object({
  networkIds: z.array(z.string())
});
const FLAG_SCHEMA_MAP = {
  // Feature gates
  ["activity_logs"]: z.boolean(),
  ["show_theme_toggle"]: z.boolean(),
  ["product_timeseries_charts"]: z.boolean(),
  ["show_disable_api_key_toggle"]: z.boolean(),
  ["whitelist_ip_ranges"]: z.boolean(),
  ["show_team_ip_allowlist"]: z.boolean(),
  ["show_method_and_network_in_error_alert"]: z.boolean(),
  ["admin_access_keys"]: z.boolean(),
  ["rbac"]: z.boolean(),
  ["transaction_lifecycle_dashboard"]: z.boolean(),
  ["tenderly_debug"]: z.boolean(),
  // Experiments
  ["webhook_creation_template"]: z.object({
    is_test: z.boolean()
  }),
  // Dynamic configs
  ["featured_chains"]: z.object({
    featuredChainIds: z.array(z.string()),
    popularChainIds: z.array(z.string())
  }),
  ["just_shipped_cards"]: z.object({
    cards: z.array(JustShippedCardSchema)
  }),
  ["announcement_banner"]: z.object({
    banners: z.array(AnnouncementBannerSchema)
  }),
  ["outage_banner"]: z.object({
    enabled: z.boolean(),
    message: z.string()
  }),
  ["schedule_call_popover"]: z.object({
    ctaText: z.string(),
    ctaUrl: z.string().url(),
    description: z.string(),
    openPopoverText: z.string(),
    enabled: z.boolean()
  }),
  ["wallet_services"]: z.object({
    gasManager: UnvalidatedNetworkIdsSchema
  }),
  ["global_banner"]: z.object({
    contentMd: z.string(),
    variant: z.enum([
      "info",
      "warning",
      "error"
    ])
  }),
  ["custom_jwt_provider"]: z.boolean()
};
const flagSchemaMap = z.object(FLAG_SCHEMA_MAP);
const FLAG_DEFAULTS = {
  // Feature gates
  ["activity_logs"]: false,
  ["show_theme_toggle"]: false,
  ["product_timeseries_charts"]: false,
  ["custom_jwt_provider"]: false,
  ["show_disable_api_key_toggle"]: false,
  ["whitelist_ip_ranges"]: false,
  ["show_team_ip_allowlist"]: false,
  ["show_method_and_network_in_error_alert"]: false,
  ["admin_access_keys"]: false,
  ["rbac"]: false,
  ["transaction_lifecycle_dashboard"]: false,
  ["tenderly_debug"]: false,
  // Experiments
  ["webhook_creation_template"]: {
    is_test: false
  },
  // Dynamic configs
  ["announcement_banner"]: {
    banners: []
  },
  ["featured_chains"]: {
    featuredChainIds: [],
    popularChainIds: []
  },
  ["just_shipped_cards"]: {
    cards: []
  },
  ["outage_banner"]: {
    enabled: false,
    message: ""
  },
  ["schedule_call_popover"]: {
    ctaText: "",
    ctaUrl: "",
    description: "",
    openPopoverText: "",
    enabled: false
  },
  ["wallet_services"]: {
    gasManager: {
      networkIds: []
    }
  },
  ["global_banner"]: {
    contentMd: "",
    variant: "info"
  }
};
export {
  FLAG_DEFAULTS,
  FLAG_SCHEMA_MAP,
  Flag,
  FlagEnum,
  flagSchemaMap
};
//# sourceMappingURL=flags.js.map